import type {
  LC_CheckInLocationItem,
  CheckInLocationItem,
  CheckInLocationPage,
  LC_CheckInLocationListOut,
  LC_GeolocationRecord,
  LC_GeolocationListOut,
  GeolocationRecord,
  GeolocalizationData,
  LC_LocationEmployeeItem,
  LocationEmployeeItem,
  LC_AssignedLocationSummaryItem,
  LC_AssignedLocationSummaryOut,
  AssignedLocationSummaryItem,
  AssignedLocationSummaryPage,
} from './checkInLocation.types';


export function mapCheckInLocationItemToModel(item: LC_CheckInLocationItem): CheckInLocationItem {
  return {
    id: item.locationId,
    name: item.name ?? '',
    address: item.address,
    hasGeolocation: item.hasGeolocation,
    communeId: item.communeId,
    telework: item.isRemoteWork,
    createdAt: item.createdAt ?? '',
    status: item.isActive ? 'active' : 'inactive',
  };
}

export function mapCheckInLocationPageToModel(
  result: LC_CheckInLocationListOut,
): CheckInLocationPage {
  return {
    items: (result.data ?? []).map(mapCheckInLocationItemToModel),
    totalRecords: result.pagination?.totalRecords ?? 0,
  };
}

export function mapGeolocationRecordToModel(item: LC_GeolocationRecord): GeolocationRecord {
  return {
    id: item.geoLocationId,
    provider: item.provider ?? '',
    latitude: Number(item.latitude),
    longitude: Number(item.longitude),
  };
}

export function mapGeolocationListToModel(result: LC_GeolocationListOut): GeolocalizationData {
  return {
    locationName: result.locationName ?? '',
    locationAddress: result.locationAddress ?? null,
    mapUrl: result.mapUrl ?? null,
    records: (result.items ?? []).map(mapGeolocationRecordToModel),
  };
}

export function mapLocationEmployeeItem(raw: LC_LocationEmployeeItem): LocationEmployeeItem {
  return {
    employeeId: raw.employeeId,
    employeeName: raw.employeeName?.trim() ?? '',
    employeeTaxIdentificationNumber: raw.employeeTaxIdentificationNumber?.trim() ?? '',
  };
}

export function mapAssignedLocationSummaryItem(
  raw: LC_AssignedLocationSummaryItem,
): AssignedLocationSummaryItem {
  return {
    id: raw.locationId,
    name: raw.locationName ?? '',
    assignedCount: raw.assignedEmployeesCount,
    employees: (raw.employees ?? []).map(mapLocationEmployeeItem),
  };
}

export function mapAssignedLocationSummaryPage(
  raw: LC_AssignedLocationSummaryOut,
): AssignedLocationSummaryPage {
  return {
    items: (raw.data ?? []).map(mapAssignedLocationSummaryItem),
    totalRecords: raw.pagination?.totalRecords ?? 0,
  };
}
